module.exports = __webpack_public_path__ + "static/media/Logo_Circle.63a4b85f.svg";